import { useState } from "react";
import { Modal, Row, Space } from "antd";
import { toastError, toastSuccess } from "helpers/toasters";
import PrimaryButton from "modules/SubComponents/Buttons/PrimaryButton";
import SecondaryButton from "modules/SubComponents/Buttons/SecondaryButton";
import { deleteCodes } from "Network";

export default function DeleteModal({
  open,
  onCancel,
  SubHeader,
  handleDeleteCodes,
  loading,
}) {
  return (
    <Modal
      title={SubHeader}
      onCancel={onCancel}
      open={open}
      footer={false}
      closable={false}
    >
      <h6 className="text-center">
        Are you sure you want to delete all request codes?
      </h6>
      <Row className="mrg-ys-30 mrg-x-auto d-flex justify-content-center">
        <Space size={20}>
          <SecondaryButton buttonName={"Cancel"} onClick={onCancel} />
          <PrimaryButton
            buttonName={"Ok"}
            onClick={handleDeleteCodes}
            loading={loading}
          />
        </Space>
      </Row>
    </Modal>
  );
}
